import ShellCard from "../../components/ShellCard";
import heroBanner from "../../assets/images/pages/cursos-en-espanol/curso-de-preparatoria.jpg";
import "./FourHourBDI.css";

const CursoDePreparatoria = () => {
    return (
        <>
            <section className="hero-slider-section">
                <div
                    className="hero-banner"
                    style={{
                        backgroundImage: `url(${heroBanner})`,
                    }}
                >
                    <div className="banner-text-container">
                        <div className="banner-heading">
                            <h1 className="banner-title">
                                Curso de Preparatoria
                                <br />
                                <span style={{ fontSize: "0.6em", fontWeight: "normal" }}>Prepararse para el Examen Teórico</span>
                            </h1>
                        </div>
                    </div>
                </div>
            </section>

            <main className="bdi-page mb-3">
                <div className="container mt-5">
                    <div className="row mb-5">
                        <div className="col-12">
                            <ShellCard>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="mb-3">
                                            <h3 className="mb-4 text-warning">Descripción del Curso</h3>
                                            <p>
                                                El Curso de Preparatoria le dará las herramientas que necesita para pasar el Examen Teórico. Este contiene preguntas de práctica que se encuentran en el Examen que el Departamento de Vehículos provee. El examen de preparatoria lo ayudara con el examen actual y lo ayudara a incrementar sus posibilidades de pasar el Examen Teórico en el primer intento. Usted será capaz de tomar diferentes exámenes con preguntas al azar. También, podrá revisar y estudiar las respuestas cuando termine. Este curso, como tal, paga por si mismo ya que reduce los costos de retomar el examen en el DMV.
                                            </p>
                                        </div>

                                        <div className="row justify-content-center py-5">
                                            <div
                                                className="p-4 rounded mb-4 text-center col-12 col-lg-6"
                                                style={{
                                                    backgroundColor: "#252525",
                                                    borderRadius: "8px",
                                                    border: "2px solid var(--metro-yellow)",
                                                }}
                                            >
                                                <h3 className="text-white mb-3">Curso de Preparatoria</h3>
                                                <div className="mb-3">
                                                    <span
                                                        className="display-5 fw-bold text-warning"
                                                    >
                                                        $19.95
                                                    </span>
                                                </div>

                                                <div className="d-flex flex-wrap justify-content-center gap-3">
                                                    <a
                                                        href="https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=NTE2"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-lg px-4 py-2 fw-bold text-dark metro-btn-primary text-decoration-none"
                                                    >
                                                        Registrese Ahora!
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ShellCard>
                        </div>
                    </div>
                </div>
                <div className="container" style={{ marginBottom: "32px" }}>
                    <div className="row text-white">
                        <p>
                            Superb Customer Service
                        </p>
                        <p>
                            At Metro we always aim to provide an exceptional and pain free educational experience. We do this by only offering state approved courses that use cutting edge technology and always providing first rate customer service. Here are some reviews left by past clients!
                        </p>
                    </div>
                </div>
            </main>
        </>
    );
};

export default CursoDePreparatoria;
